import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
// import getBaseUrl from '../getBaseUrl';
import { BASE_URL, getBaseUrl } from "../config";
import { getAuthApiHeaders } from "../../utils/common";
import { showSnackbar } from "./snackbar";
import { getApiErrorMessage } from "../../utils/apiError";
import secureLocalStorage from "react-secure-storage";
const baseUrl = getBaseUrl();
export const renameUserSession = createAsyncThunk(
  "renameUserSession",
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      const response = await axios.patch(
        `${baseUrl}/sessions/${payload.sessionId}/name`,
        payload.data,
        {
          headers: {
            "Content-Type": "application/json",
            "use-case": "src",
            ...getAuthApiHeaders({ includeIncomingEmail: true }),
            client: payload.client ? payload.client : "UT",
          },
          withCredentials: true,
        },
      );
      dispatch(
        showSnackbar({
          message: "Completed Successfully!",
          severity: "success",
        }),
      );
      return response.data;
    } catch (error) {
      dispatch(showSnackbar({ message: "Save Failed!", severity: "error" }));
      return rejectWithValue(getApiErrorMessage(error));
    }
  },
);
const renameUserSlice = createSlice({
  name: "rename-user",
  initialState: {
    isLoading: false,
    renameUser: "",
    isError: false,
    error: null,
    success: false,
  },
  extraReducers: (builder) => {
    builder.addCase(renameUserSession.pending, (state, action) => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(renameUserSession.fulfilled, (state, action) => {
      state.isLoading = false;
      state.renameUser = action.payload;
      state.success = true;
    });
    builder.addCase(renameUserSession.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.error = action.payload;
      state.success = false;
    });
  },
});

export default renameUserSlice.reducer;
